import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import { productIcon } from 'helpers'
import React from 'react'
import { Page, Toolbar } from 'react-onsenui'
import Forecast from '../components/Forecast'
import { appBar, primaryColor, productName, btSamplings } from '../Styles'
const ForecastByProductScreen = props => {
  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>
              Previsiones por {props.selectedForecast.productType}
            </Typography>
          </div>
          <div className="right" />
        </Toolbar>
      )}>
      <div className={props.classes.resume}>
        <Grid container spacing={16} alignItems="center">
          <Grid item xs={3}>
            <img
              alt={''}
              src={productIcon(props.selectedForecast.productIconFileName)}
              className={props.classes.productIcon}
            />
          </Grid>
          <Grid item xs={9}>
            <div>
              <Typography className={props.classes.productName}>{props.selectedForecast.productType}</Typography>
            </div>
            <div style={{ marginTop: '-6px' }}>
              <Typography className={props.classes.productTotalKg}>{props.selectedForecast.totalKg} kg.</Typography>
            </div>
            <div item className={props.classes.filters}>
              <Typography className={props.classes.filtersText}>
                Periodo:{' '}
                <b
                  className={props.classes.primaryColor}
                  dangerouslySetInnerHTML={{ __html: props.forecastsPeriodLabelSimple }}
                />
                &nbsp;&nbsp;Naves:{' '}
                <b className={props.classes.primaryColor}>
                  {props.selectedGreenhouses.length ? `${props.selectedGreenhouses.length} seleccionadas` : 'Todas'}
                </b>
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={props.classes.deliveries}>
        {props.selectedForecast.forecasts.map((forecast, index) => (
          <Forecast
            key={'fc' + forecast.totalKg + index + forecast.date}
            forecast={forecast}
            onCreateForecast={props.onCreateForecast}
          />
        ))}
      </div>
    </Page>
  )
}

export default withStyles(theme => ({
  appBar,
  primaryColor: {
    color: primaryColor,
    fontWeight: 400,
  },
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    [theme.breakpoints.down('xs')]: {
      width: 200,
      margin: 'auto',
      paddingTop: 9,
      whiteSpace: 'normal',
    },
    padding: 10,
    paddingTop: 13,
    fontWeight: 600,
    fontSize: 17,
    lineHeight: '19px',
    color: 'white',
    textAlign: 'center',
  },
  resume: {
    background: 'white',
    padding: '5px 10px 5px',
  },
  productIcon: {
    maxWidth: '100%',
  },
  productName,
  productTotalKg: {
    fontWeight: 'bold',
    fontSize: 30,
  },
  resume2: {
    paddingTop: 5,
    borderTop: '1px solid #DDD',
  },
  productNumDeliveries: {
    display: 'inline-block',
    background: '#8ACA4C',
    borderRadius: 5,
    color: 'white',
    padding: '2px 7px',
  },
  filters: {
    marginTop: 5,
    borderTop: '1px solid #DDD',
    paddingTop: 3,
  },
  filtersText: {
    fontWeight: 300,
    fontSize: 12,
    color: '#53535',
  },
  deliveries: {},
  btSamplingsContainer: {
    padding: 15,
  },
  btSamplings,
  btSamplingsIcon: {
    position: 'absolute',
    top: 5,
    right: 0,
    color: 'white',
  },
}))(ForecastByProductScreen)



// WEBPACK FOOTER //
// ./src/screens/ForecastByProductScreen.js